import CustomCard from '../../../components/card/CustomCard'
import CustomCardHeader from '../../../components/card/CustomCardHeader'
import CardBody from '../../../components/card/CardBody'
import CustomTable, {
  TableHeader,
  TableRow,
} from '../../../components/table/CustomTable'
import CardFooter from '../../../components/card/CardFooter'
import { useDispatch, useSelector } from 'react-redux'
import React, { useEffect, useState, useRef } from 'react'
import CustomTableItemLoader from '../../../components/CustomTableItemLoader'
import { tryFetchNotificationReport } from 'redux/slices/notificationReportSlice'
import NotificationReportItem from './NotificationReportItem'
import Pagination from 'components/Pagination'
import CustomButton from 'components/CustomButton'
import DatePicker from 'components/datepicker/DatePicker'
import { CommonTabGroup } from 'components/tab/TabGroup'
import { notificationType } from '../constants'
import { setActiveTab } from 'redux/slices/notificationReportSlice'
import CustomIcon from 'components/CustomIcon'

const NotificationReportingTable = () => {
  const dispatch = useDispatch()
  const [selectedFromDate, setSelectedFromDate] = useState()
  const [selectedToDate, setSelectedToDate] = useState()
  const dateTimeFromRef = useRef()
  const dateTimeToRef = useRef()

  const { loading, data, error, totalPage, page, selectedTab } = useSelector(
    (state) => state.notificationReport,
  )

  useEffect(() => {
    handleFetchReport(1, notificationType[0])
    return () => {
      dispatch(setActiveTab(notificationType[0]))
    }
  }, [])

  const handlePageClick = (data) => {
    let currentPage = data.selected + 1
    if (currentPage !== page) handleFetchReport(currentPage, selectedTab)
  }

  const handleFetchReport = (page, tab) => {
    dispatch(
      tryFetchNotificationReport({
        page:
          selectedFromDate?.length > 0 || selectedToDate?.length > 0 ? 1 : page,
        dateFrom: selectedFromDate,
        dateTo: selectedToDate,
        type: tab.value,
      }),
    )
  }

  const clearDate = (tab) => {
    setSelectedToDate()
    setSelectedFromDate()
    dateTimeFromRef.current.value = ''
    dateTimeToRef.current.value = ''
    dispatch(
      tryFetchNotificationReport({
        page: 1,
        type: tab?.value ?? selectedTab.value,
      }),
    )
  }

  const Tab = ({ tab }) => {
    return (
      <div
        className={`${selectedTab === tab
            ? 'text-rand-100 border-secondary-500'
            : 'text-rand-200 border-transparent hover:border-rand-300 cursor-pointer'
          } focus:outline-none px-6 py-3 text-sm font-medium border-b-2`}
        onClick={() => {
          if (selectedTab !== tab) {
            dispatch(setActiveTab(tab))
            clearDate(tab)
          }
        }}
      >
        {tab.label}
      </div>
    )
  }

  return (
    <CustomCard>
      <CustomCardHeader color="blue" contentPosition="left">
        <h2 className="text-white text-2xl">Notification Report</h2>
      </CustomCardHeader>
      <CardBody>
        <CommonTabGroup>
          {notificationType.map((n, index) => (
            <Tab key={`${n}-${index}`} tab={n} />
          ))}
        </CommonTabGroup>
        <div className="flex items-end space-x-4 mb-4">
          <div className="flex space-x-4">
            <>
              <DatePicker
                name="Start Date"
                selectedDate={selectedFromDate}
                onChange={(date) => {
                  setSelectedFromDate(date)
                }}
                ref={dateTimeFromRef}
                isHorizontal={true}
              />
              <DatePicker
                name="End Date"
                selectedDate={selectedToDate}
                onChange={(date) => {
                  setSelectedToDate(date)
                }}
                ref={dateTimeToRef}
                isHorizontal={true}
              />
            </>
          </div>
          <div className="flex space-x-2 items-center mb-1">
            <CustomButton
              onClick={() => {
                handleFetchReport(1, selectedTab)
              }}
              className="px-8"
              disabled={!selectedToDate?.length && !selectedFromDate?.length}
            >
              Search
            </CustomButton>
            {!selectedToDate?.length && !selectedFromDate?.length ? (
              <></>
            ) : (
              <div
                onClick={clearDate}
                className="flex items-center space-x-0.5 cursor-pointer text-error-500"
              >
                {' '}
                <CustomIcon icon="cancel" size="lg" />
                <span className="text-sm mt-0.5 leading-none">
                  Clear Filter
                </span>
              </div>
            )}
          </div>
        </div>
        <CustomTable>
          <thead>
            <TableRow>
              <TableHeader>Notification</TableHeader>
              <TableHeader className="w-36">Created At</TableHeader>
              <TableHeader className="w-36">No. of Recipients</TableHeader>
              {notificationType[0].value === selectedTab.value && (
                <TableHeader className="w-36 text-right">
                  Click Count
                </TableHeader>
              )}
            </TableRow>
          </thead>
          {loading || error.length || !data.length ? (
            <CustomTableItemLoader
              loading={loading}
              error={error}
              isEmpty={!data.length}
              count={10}
              colSpan={6}
              key="notification-scheduled"
              retry={() => {
                handleFetchReport(page, selectedTab)
              }}
            />
          ) : (
            <tbody>
              {data?.map((not, index) => (
                <NotificationReportItem
                  item={not}
                  key={index}
                  selectedTab={selectedTab}
                />
              ))}
            </tbody>
          )}
        </CustomTable>
      </CardBody>
      {!(loading || error.length > 0 || !data.length) && (
        <CardFooter>
          <Pagination
            pageCount={totalPage}
            onPageChange={handlePageClick}
            forcePage={page - 1}
          />
        </CardFooter>
      )}
    </CustomCard>
  )
}

export default NotificationReportingTable
